export default __webpack_public_path__ + "static/media/locationicon.c548bdcd.svg";